import { Configuration } from '@ibe/api';

class ApiConfiguration extends Configuration {}

export default ApiConfiguration;
